/** @jsx jsx */
import { type SerializedStyles, css, jsx } from '@emotion/react';

import * as React from 'react';

import { IconButton, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/coursera-toolbar';

const styles = {
  panel: css`
    color: var(--cds-color-neutral-primary-invert);
    padding: 45px var(--cds-spacing-400);
    border-radius: 16px;
    border: 2px solid var(--cds-color-interactive-secondary-pressed);
    background-color: var(--cds-color-interactive-secondary);
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
  `,
  panelHeader: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--cds-spacing-150);
    margin-bottom: var(--cds-spacing-400);

    @media (max-width: 840px) {
      flex-direction: column;
      align-items: flex-start;
    }
  `,
  closeButton: css`
    position: absolute;
    right: 5px;
    top: 5px;
  `,
};

/**
 * Generic Panel component for the Coursera Toolbar
 */
type PanelProps = {
  onClose: () => void;
  title: React.ReactNode;
  icon?: string;
  children: React.ReactNode;
  headerContent?: React.ReactNode;
  containerCss?: SerializedStyles;
};

export const Panel = ({ onClose, title, icon, children, headerContent, containerCss }: PanelProps) => {
  return (
    <div css={[styles.panel, containerCss]}>
      <IconButton intent="close" onClick={onClose} variant="ghostInvert" size="small" css={styles.closeButton} />
      <div css={styles.panelHeader}>
        <div>
          {icon && <img src={icon} alt={_t('Panel Icon')} />}
          <Typography2 component="h2" color="invertBody" variant="titleXSmall">
            {title}
          </Typography2>
        </div>
        <div>{headerContent}</div>
      </div>

      {children}
    </div>
  );
};

export default Panel;
